/**
 * Hook for reading the grid dependency-injection config.
 *
 * Returns the merged config from the nearest DataGridConfigProvider. When no
 * provider is mounted it returns GENERIC_DEFAULTS, so grids render safely in
 * tests and non-ODL contexts without throwing.
 *
 * Contains:
 * - useDataGridConfig — read the current DataGridConfig context value
 */

import { useContext } from 'react';

import DataGridConfigContext from './DataGridConfigContext';

/**
 * Returns the current DataGridConfig. All grid machinery reads its ODL-specific
 * dependencies through this hook; ODL injects them once at the app root via
 * DataGridConfigProvider.
 *
 * @returns {typeof import('./DataGridConfigContext').GENERIC_DEFAULTS}
 */
export default function useDataGridConfig() {
  return useContext(DataGridConfigContext);
}
